import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'i18n'
import { validators } from 'utils/form'
import { ExternalPrimaryLink } from 'components/styled/typography'
import { Flex } from 'components/styled/containers/flex'
import { ControlCheckbox } from 'components/form-components/control-checkbox'
import FormErrors from 'components/form-components/form-errors'
import { BodyStyle } from 'components/styled/typography/styles'

const { isRequired } = validators

const propTypes = {
  agreed: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  i18n: PropTypes.shape({
    supportLink: PropTypes.string,
    customSupportLinkText: PropTypes.func,
    agreeTos: PropTypes.object.isRequired,
  }).isRequired,
  model: PropTypes.string.isRequired,
  privacyLink: PropTypes.string,
  agreeTosLink: PropTypes.string,
  agreeTosLinkText: PropTypes.string,
  onChange: PropTypes.func,
  validators: PropTypes.shape({}),
  showError: PropTypes.shape({}),
  customSupport: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.sring,
    companyName: PropTypes.string,
  }),
}

const defaultProps = {
  onChange: () => {},
  disabled: false,
  privacyLink: null,
  validators: { isRequired },
  showError: undefined,
  customSupport: undefined,
  agreeTosLink: undefined,
  agreeTosLinkText: undefined,
}

const CustomLabel = styled.div`
  ${BodyStyle};
  display: inline;
`

const InfoContainer = styled.div`
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.space.s12};

  a {
    color: ${({ theme }) => theme.color.primary110};
  }
`

export const AgreeTos = ({
  agreed,
  disabled,
  i18n,
  privacyLink,
  agreeTosLink,
  agreeTosLinkText,
  onChange,
  model,
  validators,
  customSupport,
  showError,
}) => {
  const [showInfo, setShowInfo] = useState(false)

  const getSupportLinkHtml = () => {
    if (customSupport) {
      if (customSupport.type === 'email') {
        return i18n.agreeTos.customSupportPrivacyInfo(
          `<a href="mailto:${customSupport.value}">${customSupport.value}</a>`
        )
      }

      if (customSupport.type === 'link') {
        return i18n.agreeTos.customSupportPrivacyInfo(
          `<a href="${customSupport.value}" target="_blank" rel="noopener noreferrer">
            ${customSupport.companyName}
          </a>`
        )
      }
    }

    return i18n.agreeTos.privacyInfo(
      `<a href="mailto:${i18n.supportLink}">${i18n.supportLink}</a>`
    )
  }

  const privacyPolicyLink = (
    <ExternalPrimaryLink
      className="privacy-link"
      href={privacyLink || i18n.agreeTos.privacyLink}
      target="_blank"
    >
      {i18n.agreeTos.privacyLinkText}
    </ExternalPrimaryLink>
  )

  const ppLink = (
    <CustomLabel>
      {`${i18n.agreeTos.privacyPolicyText} `}
      {privacyPolicyLink}
    </CustomLabel>
  )

  const termsLink = (
    <ExternalPrimaryLink
      className="terms-link"
      href={agreeTosLink || i18n.agreeTos.termsLink}
      target="_blank"
    >
      {agreeTosLinkText || i18n.agreeTos.termsLinkText}
    </ExternalPrimaryLink>
  )
  const supportLinkHtml = getSupportLinkHtml()
  const checkBoxLabel = (
    <CustomLabel>
      {` ${i18n.agreeTos.termsText1} `}
      {termsLink}
      {` ${i18n.agreeTos.termsText2} *`}
    </CustomLabel>
  )

  const componentProps = {
    disabled,
    value: agreed,
    label: checkBoxLabel,
  }

  return (
    <Flex
      className="agreetos-container"
      flexDirection="column"
      name={model}
      onClick={() => disabled && setShowInfo(true)}
    >
      <ControlCheckbox
        model={model}
        validators={validators}
        componentProps={componentProps}
        onChange={onChange}
      />
      {showInfo && (
        <InfoContainer
          data-testid="disabled-info-text"
          dangerouslySetInnerHTML={{ __html: supportLinkHtml }}
        />
      )}
      {agreed && disabled ? null : (
        <FormErrors model={model} show={showError} />
      )}
      {ppLink}
    </Flex>
  )
}

AgreeTos.propTypes = propTypes
AgreeTos.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(AgreeTos)
